module.exports = __webpack_public_path__ + "img/036-central-african-republic.d5c6b378.svg";